"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIME_FORMAT = exports.DEFAULT_DATE_FORMAT = exports.DEFAULT_FORMAT = exports.DAY_IN_MS = exports.types = exports.positions = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var positions = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right'
};
exports.positions = positions;
var types = {
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'datetime'
};
exports.types = types;
var DAY_IN_MS = 86400000;
exports.DAY_IN_MS = DAY_IN_MS;

var DEFAULT_FORMAT = _objectSpread(_objectSpread({}, DEFAULT_DATE_FORMAT), DEFAULT_TIME_FORMAT);

exports.DEFAULT_FORMAT = DEFAULT_FORMAT;
var DEFAULT_DATE_FORMAT = {
  year: true,
  month: true,
  day: true
};
exports.DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
var DEFAULT_TIME_FORMAT = {
  hour: true,
  minute: true,
  second: true,
  millisecond: false,
  hour12: false
};
exports.DEFAULT_TIME_FORMAT = DEFAULT_TIME_FORMAT;
//# sourceMappingURL=constants.js.map